// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"0baea80c","549":"797862bf"}[chunkId] + ".chunk.js";
};